import { Box } from '@mui/material';

export const ButtonGroup = ({ children }) => (
  <Box width="100%" display="flex" justifyContent="flex-end">
    {children}
  </Box>
);
